import styled from 'styled-components'

export const StyledMonitorInfo = styled.div`
    color: ${({ theme, active }) => active ? theme.grassyGreen : theme.brownGrey}
`